import { Link } from 'react-router-dom';

const RELATED_GUIDES = [
  {
    icon: 'ri-home-4-line',
    title: 'Cabins in Highlands, NC',
    desc: 'A complete guide to cabin rentals in Highlands, North Carolina — from luxury retreats to cozy mountain escapes.',
    link: '/cabins-in-highlands-nc',
    label: 'View Cabin Guide',
  },
  {
    icon: 'ri-footprint-line',
    title: 'Pet Friendly Cabins in Highlands, NC',
    desc: 'Traveling with a dog? This guide covers the best pet-friendly cabin rentals in Highlands, NC.',
    link: '/pet-friendly-cabins-highlands-nc',
    label: 'View Pet Friendly Guide',
  },
  {
    icon: 'ri-drop-line',
    title: 'Cabins Near Glen Falls',
    desc: 'Stay within walking distance of one of the most beautiful waterfalls in the Blue Ridge Mountains.',
    link: '/cabins-near-glen-falls-highlands-nc',
    label: 'View Waterfall Cabins',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Things to Do in Highlands, NC',
    desc: 'Waterfalls, hiking, restaurants, and more — a local guide to the best activities in Highlands, North Carolina.',
    link: '/things-to-do',
    label: 'Explore Activities',
  },
];

export default function VRInternalLinksSection() {
  return (
    <section className="bg-[#EDE8E0] py-20 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ More Guides</p>
          <h2 className="font-cormorant text-4xl text-[#1A1A18] font-light">
            Related Guides for<br /><em className="italic">Highlands, NC</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {RELATED_GUIDES.map((guide) => (
            <Link
              key={guide.title}
              to={guide.link}
              className="bg-white rounded-2xl p-7 flex flex-col gap-4 hover:bg-[#FAFAF8] transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EDE8E0] group-hover:bg-[#D4DDD8] transition-colors">
                <i className={`${guide.icon} text-[#2D4A3E] text-base`} />
              </div>
              <div>
                <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium mb-2 leading-snug">{guide.title}</h3>
                <p className="text-[#5C5850] font-jost text-xs leading-relaxed mb-4">{guide.desc}</p>
                <span className="text-[#2D4A3E] text-xs font-jost font-medium tracking-wide flex items-center gap-1.5">
                  {guide.label}
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs" />
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
